const Photo = () => {
  return (
    <div className="flex justify-center content-center  w-full">
      <img
        src="../images/MainPhoto.jpg"
        alt="mainPhoto"
        className="w-full object-cover"
        style={{ height: "500px" }}
      />
    </div>
  );
};

export default Photo;
